/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Backup_Interval_LabelInputs */



/**
* | output |
* | --- |
* | "Backup Interval (minutes)" |
*
* @param {Options_Backup_Interval_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_backup_interval_label = /** @type {((inputs?: Options_Backup_Interval_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Backup_Interval_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Intervalle de sauvegarde (minutes)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Backup-Intervall (Minuten)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Intervallo di backup (minuti)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Интервал резервного копирования (минуты)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Intervalo de copia de seguridad (minutos)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("备份间隔（分钟）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("バックアップ間隔（分）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बैकअप अंतराल (मिनटों में)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Intervalo de backup (minutos)")
	return /** @type {LocalizedString} */ ("Backup Interval (minutes)")
});